'use client';

import { useEffect } from 'react';
import { landingPageEvents } from '@/components/PostHogProvider';

interface LearnPageTrackerProps {
  slug: string;
  category: string;
}

/**
 * Client component that tracks learn page views.
 *
 * Fires `learn_page_viewed` event on mount with slug and category context.
 * It renders nothing to the DOM - it only enables the tracking behavior.
 *
 * @example
 * ```tsx
 * // In a learn page server component
 * export default function LearnPage({ params }) {
 *   return (
 *     <>
 *       <LearnPageTracker slug={params.slug} category={concept.category} />
 *       <main>...</main>
 *     </>
 *   );
 * }
 * ```
 */
export function LearnPageTracker({ slug, category }: LearnPageTrackerProps): null {
  useEffect(() => {
    landingPageEvents.learnPageViewed(slug, category);
  }, [slug, category]);

  return null;
}
